import React from 'react';


const IconSettingGroup: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3.5599 5.43614L8.00007 2.87261L12.4402 5.43614V10.5632L8.00007 13.1267L3.5599 10.5632V5.43614ZM8.00007 1.33301L13.7736 4.66634V11.333L8.00007 14.6663L2.22656 11.333V4.66634L8.00007 1.33301ZM8.00007 9.99967C9.10464 9.99967 10.0001 9.10424 10.0001 7.99967C10.0001 6.8951 9.10464 5.99967 8.00007 5.99967C6.8955 5.99967 6.00007 6.8951 6.00007 7.99967C6.00007 9.10424 6.8955 9.99967 8.00007 9.99967Z"
              fill="white"/>
    </svg>


);

export default IconSettingGroup;